import MongoService from './mongo.service'
import MessageDialog from '../libs/message-dialog/'
import moment from 'moment'
import { escape } from '../libs/utils'

export const DEFAULT_SEARCH_HOUR_RANGE = 3

export async function search ({ requestId, date = undefined, hourRange = undefined, startTime = undefined, endTime = undefined, logGroupName = 'gsr-lambda-bot-prod-execute' }) {
  if (!startTime) {
    startTime = +moment.utc(date).add(-hourRange || -DEFAULT_SEARCH_HOUR_RANGE, 'hours')
  }
  if (!endTime) {
    endTime = +moment.utc(date).add(hourRange || DEFAULT_SEARCH_HOUR_RANGE, 'hours')
  }
  const message = await MongoService.cloudwatch.search({ logGroupName, requestId, startTime, endTime })
  return { requestId, message, date, startTime, endTime }
}

export async function showResult ({ requestId, message }) {
  await MessageDialog.showMessage({
    type: null,
    width: '80%',
    html: `
      <div class='v-card theme--dark red lighten-1 mt-3'>
        <div class='v-card__title title'>Request ID: ${requestId}</div>
        <div class='v-card__text white black--text grey lighten-5'><pre>${escape(message)}</pre></div>
      </div>`
  })
}
